export enum AuthErrorMessage {
    invalidEmail = "Invalid email",
    invalidInvite = "Invalid invite",
    forbiddenInvite = "Invalid invite. Contact Admin for help",
    inappropriateInvite = "Invitation email doesn't match registration email",
    invalidProvider = "Email is already in use. Try a different provider",
    lackPermissions = "You don't have permissions to view this page. Ask admin for assistance.",
    invalidCredential = "Email or Password is incorrect",
    differentPasswords = "Passwords don't match. Check again",
    emailAlreadyInUse = "Email is already in use",
    weakPassword = "Password must be 6 characters or longer",
    verificationEmailFailed = "Failed to send verification email. Please try again later",
    directoryNotAllowed = "This Microsoft account is not in a directory this organization accepts",
    domainNotAllowed = "Accounts outside this organization's email domains cannot sign in",
    passwordPolicy = "Password does not meet this organization's requirements",
    passwordExpired = "Your password has expired. Set a new one to continue",
    methodNotAllowed = "This sign-in method is not allowed for this organization",
    samePassword = "The new password must differ from the current one",
    tooManyAttempts = "Too many attempts. Please wait a moment and try again",
    ssoLinkRequired = "An account with this email already signs in with a password. Enter that password once to connect it to single sign-on",
    ssoLinkMaybe = "An account with this email already exists. If it signs in with a password, enter that password once to connect it to single sign-on; otherwise sign in the way the account was created",
    ssoLinkNoPassword = "This email does not sign in with a password here. Sign in the way the account was created, or ask your administrator",
    ssoLinkFailed = "The password was not accepted, so the accounts were not connected",
    ssoLinkUseLogin = "An account with this email already signs in with a password. Use Log In to connect it to single sign-on",
    default = "Something went wrong. Please try again later"
}
